import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleWishlist, wishlistSelector } from './WishlistPage.duck';

export const useWishlist = () => {
  return useSelector(wishlistSelector);
};

export const useWishlistListing = listingId => {
  const dispatch = useDispatch();
  const wishlistData = useWishlist();
  const { wishlist } = wishlistData;

  return {
    ...wishlistData,
    isInWishlist: useMemo(() => wishlist.includes(listingId), [wishlist, listingId]),
    toggleWishlist: useCallback(() => dispatch(toggleWishlist({ listingId })), [listingId]),
  };
};
